module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n            Détail d'un concert\n        ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-music"
  }, [_vm._v(" Gestion des concerts")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Détail")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('header', [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'concerts.edit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Editer le concert\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Concert N° " + _vm._s(_vm.$route.params.id))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('section', {
    attrs: {
      "id": "event"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Concert : " + _vm._s(_vm.concert.name))]), _vm._v(" "), _c('li', [_vm._v("Organisateur : " + _vm._s(_vm.concert.organizer))]), _vm._v(" "), _c('li', [_vm._v("Date : " + _vm._s(_vm.concert.event_day))])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "stats"
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', [_c('li', [_vm._v("CA réalisé : " + _vm._s(_vm.turnover.total) + "€")]), _vm._v(" "), _c('li', [_vm._v("\n                            Places vendues : " + _vm._s(_vm.turnover.sumTickets) + "\n                            "), _c('a', {
    attrs: {
      "title": "Voir le détail",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dom.dropdown.sold = !_vm.dom.dropdown.sold
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dom.dropdown.sold),
      expression: "dom.dropdown.sold"
    }]
  }, _vm._l((_vm.tickets), function(ticket) {
    return _c('li', [_vm._v("Tarif " + _vm._s(ticket.name) + " : " + _vm._s(ticket.totalTickets))])
  }))]), _vm._v(" "), _c('li', [_vm._v("Places restantes : " + _vm._s(_vm.stockTotal) + "\n                            "), _c('a', {
    attrs: {
      "title": "Voir le détail",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dom.dropdown.stock = !_vm.dom.dropdown.stock
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dom.dropdown.stock),
      expression: "dom.dropdown.stock"
    }]
  }, _vm._l((_vm.tickets), function(ticket) {
    return _c('li', [_vm._v("Tarif " + _vm._s(ticket.name) + " : " + _vm._s(ticket.stock))])
  }))])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "orders"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(order.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.firstname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.quantity_normal == null ? 0 : order.quantity_normal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.quantity_reduced == null ? 0 : order.quantity_reduced))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.quantity_group == null ? 0 : order.quantity_group))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.payment_id))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("\n                    Retour à la liste\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.print($event)
      }
    }
  }, [_vm._v("Imprimer")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exportToCsv($event)
      }
    }
  }, [_vm._v("Exporter")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h4', [_vm._v("Informations générales du concert")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h4', [_vm._v("Statistiques")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h4', [_vm._v("Liste des commandes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Numéro commande")]), _vm._v(" "), _c('th', [_vm._v("Nom du client")]), _vm._v(" "), _c('th', [_vm._v("Prénom du client")]), _vm._v(" "), _c('th', [_vm._v("Quantité prix normal")]), _vm._v(" "), _c('th', [_vm._v("Quantité prix réduit")]), _vm._v(" "), _c('th', [_vm._v("Quantité prix groupe")]), _vm._v(" "), _c('th', [_vm._v("Mode d'envoi")]), _vm._v(" "), _c('th', [_vm._v("Total commande")]), _vm._v(" "), _c('th', [_vm._v("Numéro paiement")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d67c6c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/Show.vue
// module id = 123
// module chunks = 2